<template>
    <router-link :to="{ name: 'emergency.new', query: $route.query }" class="bg-blue hover:bg-blue-dark rounded text-sm text-white font-semibold uppercase tracking-wide block text-center w-full px-4 py-3 mt-3">{{ $t('Enable_the_appointment_alert') }}</router-link>
</template>

<script>
export default {
    name: 'waiting-list-button',
}
</script>


// WEBPACK FOOTER //
// src/components/Patient/WaitingListButton.vue